import { useQuery } from '@tanstack/react-query';
import { fetchConnectedProviders } from './integrations.ts';

/**
 * Which calendars the user connected. `noCalendar` stays false until the answer
 * is in, so a page never claims there is no calendar while it is still asking.
 */
export function useConnectedCalendars() {
  const { data: connected } = useQuery({
    queryKey: ['integrations'],
    queryFn: fetchConnectedProviders,
  });
  const noCalendar = connected !== undefined && !connected.microsoft && !connected.google;

  return { connected, noCalendar };
}
